(() => {
  if (window.__btAddiCampaignLoaded) return;
  window.__btAddiCampaignLoaded = true;
  const emit = (name, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
    window.dispatchEvent(new CustomEvent(name, { detail }));
  };
  const observeOnce = (selector, eventName) => {
    document.querySelectorAll(selector).forEach((node) => {
      if (node.dataset.btAddiObserved) return;
      node.dataset.btAddiObserved = 'true';
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        emit(eventName, { path: location.pathname });
        observer.disconnect();
      }, { threshold: 0.35 });
      observer.observe(node);
    });
  };
  const bind = () => {
    observeOnce('[data-bt-addi-home]', 'bt_addi_banner_view');
    observeOnce('[data-bt-addi-landing]', 'bt_addi_landing_view');
    observeOnce('[data-bt-addi-cart]', 'bt_addi_cart_info_view');
    document.querySelectorAll('[data-bt-addi-home] a, [data-bt-addi-click]').forEach((link) => link.addEventListener('click', () => emit('bt_addi_banner_click', { path: location.pathname }), { once: true }));
    document.querySelectorAll('[data-bt-addi-product-info]').forEach((link) => link.addEventListener('click', () => emit('bt_addi_product_info_click', { path: location.pathname }), { once: true }));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', bind, { once: true }) : bind();
  document.addEventListener('shopify:section:load', bind);
})();
